// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"469":"0e28b7f0","793":"81516f87"}[chunkId] + ".chunk.css";
};